// src/services/authService.ts
import axios from "axios";

// Base API URL - change this to your backend URL
// const API_BASE_URL = "http://localhost:8000"; // Change in production
const API_BASE_URL = import.meta.env.VITE_API_PATH as string;
// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests automatically
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// User interface
interface User {
  id: number;
  f_name?: string;
  m_name?: string;
  l_name?: string;
  gender?: string;
  phone?: string;
  birth_date?: string;
  email?: string;
  username?: string;
  role?: string;
  status?: boolean;
  created_at?: string;
}

// Login response interface
interface LoginResponse {
  access_token: string;
  token_type: string;
  user: User;
}

// Auth API methods
export const authAPI = {
  // Login
  login: async (username: string, password: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>("/auth/login", {
      username,
      password,
    });
    return response.data;
  },

  // Logout
  logout: async (): Promise<void> => {
    await apiClient.post("/auth/logout");
  },

  // Get current user
  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get<User>("/auth/me");
    return response.data;
  },
};

// Export axios instance for other API calls
export default apiClient;